import { Component, OnInit, ChangeDetectorRef, DoCheck, AfterViewInit, ViewChild } from '@angular/core';
import { MarketingService } from '../../../../services/marketing.service';
import { ToastrService } from 'ngx-toastr';
import { BannerModel } from '../../../../models/marketing/banner.model';
import { ModalTransferModel } from '../../../../models/modal-transfer.model';
import { BannerTableModalComponent } from '../../../modals';
import { CommonService, InternationalizationService } from '../../../../services';
import {ClrDatagrid, ClrDatagridSortOrder, ClrDatagridStateInterface} from '@clr/angular';

@Component({
  selector: 'app-bottom-banner-table',
  templateUrl: './bottom-banner-table.component.html',
  styleUrls: ['./bottom-banner-table.component.scss']
})
export class BottomBannerTableComponent implements OnInit, DoCheck, AfterViewInit {

  tableState = 0;
  selectCount = 0;
  selectedBanner: BannerModel;

  data: Array<BannerModel> = [];
  dataFiltered: Array<BannerModel> = [];

  openBannerTableModal: boolean;
  modalReference: ModalTransferModel;
  ascSort = ClrDatagridSortOrder.ASC;

  isLoading:boolean = false;

  filterItems: any = {
    imageUrl: { key: 'imageUrl', name: 'Image Url' },
    versionId: { key: 'versionId', name: 'Version ID' },
    redirectURL: { key: 'redirectURL', name: 'Redirect URL' },
    validFrom: { key: 'validFrom', name: 'Valid From' },
    validTo: { key: 'validTo', name: 'Valid To' }
}
filters = [];

@ViewChild('dataGrid') dataGrid: ClrDatagrid;

  constructor(private readonly srv: MarketingService, private readonly toastr: ToastrService,
    private readonly i18Svc: InternationalizationService,private readonly cdref: ChangeDetectorRef,
    public common: CommonService) {
    this.i18Svc.initialize();
  }

  ngOnInit() {
    this.get(false);
  }
  ngDoCheck() {
    this.reloadLbl();
}
ngAfterViewInit(){
    this.reloadLbl();
}
reloadLbl(){
       
    this.cdref.detectChanges();
}

  public refresh() {
    this.selectedBanner = null;
    this.get(true);
  }

    public get(force: boolean) {
    this.tableState = 1;
        this.srv.getBanner(2, force)
      .subscribe(data => this.onGetData(data));
  }

  private onGetData(data) {
    if (data['result']) {
      this.data = [];
      this.dataFiltered = [];
      data['result'].forEach(x => {
        this.data.push(BannerModel.parse(x, 2));
        this.dataFiltered.push(BannerModel.parse(x, 2));
      });
      this.tableState = 2;
    } else {
      this.tableState = 4;
    }
  }

  bannerAdd() {
    this.openBannerTableModal = true;
    this.modalReference = new ModalTransferModel('newBottomBanner', BannerTableModalComponent, null, null, null);
  }

  bannerEdit() {
    if (this.selectedBanner?.id) {
      this.openBannerTableModal = true;
      this.modalReference = new ModalTransferModel('Edit', BannerTableModalComponent, this.selectedBanner, null, null);
    }
  }

  onBannerTableModalClose(refresh: boolean): void {
    this.openBannerTableModal = false;
    if (refresh) {
      this.refresh();
    }
  }

  bannerDisable(): void {
    this.isLoading = true;
    if (this.selectedBanner) {
      this.srv.disableBanner(this.selectedBanner.id).subscribe(data => {
        if (data.statusCode === 200) {
          this.showSuccess(this.i18Svc.getTranslateVal('marketing_disable_info'));
          this.isLoading = false;
          this.refresh();
        } else {
          this.isLoading = false;
          this.showError(`${this.i18Svc.getTranslateVal('error_text')}: ${data.errorMessage}`);
        }
      });
    }
  }

  showSuccess(message: string): void {
    this.toastr.success(message);
  }

  showError(message: string): void {
    this.toastr.error(message);
  }

  filter(filterValue: string) {
    filterValue = filterValue?.toUpperCase();
    this.dataFiltered = this.data.filter(x =>
      x.versionId?.toString()?.toUpperCase().indexOf(filterValue) > -1
      || x.redirectUrl?.toUpperCase().indexOf(filterValue) > -1);
  }

  onGridStateChange(state: ClrDatagridStateInterface) {
    this.filters = state?.filters || [];
  }

}
